export default __webpack_public_path__ + "static/media/filter.e0e0a3de.svg";